<template>
  <div class="m-case-g1">
    <div class="g-tit-g1">
      <h3>经典案例</h3>
      <p>CLASSIC CASE</p>
    </div>
    <ul class="ul-tab-g1">
      <li :class="{ on: activeFilter === 'all' }" @click="activeFilter = 'all'">
        <a href="javascript:;">所有</a>
      </li>
      <li :class="{ on: activeFilter === 'logo' }" @click="activeFilter = 'logo'">
        <a href="javascript:;">品牌/vi/logo设计</a>
      </li>·
      <li :class="{ on: activeFilter === 'package' }" @click="activeFilter = 'package'">
        <a href="javascript:;">包装设计</a>
      </li>
      <li :class="{ on: activeFilter === 'mascot' }" @click="activeFilter = 'mascot'">
        <a href="javascript:;">吉祥物设计</a>
      </li>
      <li :class="{ on: activeFilter === 'si' }" @click="activeFilter = 'si'">
        <a href="javascript:;">si设计</a>
      </li>
      <li :class="{ on: activeFilter === 'catalog' }" @click="activeFilter = 'catalog'">
        <a href="javascript:;">画册设计</a>
      </li>
      <li :class="{ on: activeFilter === 'video' }" @click="activeFilter = 'video'">
        <a href="javascript:;">企业宣传片</a>
      </li>
    </ul>
    <div class="tab-con1 ok">
      <div v-loading="loading" element-loading-text="加载中...">
        <ul class="ul-pic-g2">
          <li v-for="(item, index) in filteredCases" :key="index">
          <div class="con" @click="goToDetail(item.id)">
            <div class="pic">
              <img v-if="item.cover" :src="item.cover" :alt="item.title" class="case-image" />
              <div v-else class="placeholder-image">{{ item.title }}</div>
            </div>
            <div class="txt">
              <div class="bg"></div>
              <div class="inner">
                <p>{{ item.title }}<br>{{ item.description }}</p>
                <a href="javascript:;" class="more" @click.stop="goToDetail(item.id)">点击查看》</a>
              </div>
            </div>
          </div>
        </li>
      </ul> 
      </div>
    </div>
  </div>
</template>

<script>
import { getCasesList, getCasesByCategory } from '@/api/cases'

export default {
  name: 'Cases',
  data() {
    return {
      activeFilter: 'all',
      cases: [],
      loading: false
    }
  },
  created() {
    this.loadCases()
  },
  computed: {
    filteredCases() {
      if (this.activeFilter === 'all') {
        return this.cases
      }
      return this.cases.filter(c => c.category === this.activeFilter)
    }
  },
  watch: {
    activeFilter(newVal) {
      if (newVal === 'all') {
        this.loadCases()
      } else {
        this.loadCasesByCategory(newVal)
      }
    }
  },
  methods: {
    // 加载所有案例
    loadCases() {
      this.loading = true
      getCasesList()
        .then(response => {
          // 若依后台返回格式: { code: 200, msg: '操作成功', data: [...] }
          if (response.code === 200) {
            this.cases = response.data || response.rows || []
          } else {
            this.$message.error(response.msg || '获取案例列表失败')
            // 如果API失败，使用默认数据作为降级方案
            this.cases = this.getDefaultCases()
          }
        })
        .catch(error => {
          console.error('获取案例列表失败:', error)
          this.$message.error('获取案例列表失败，请稍后重试')
          // 使用默认数据作为降级方案
          this.cases = this.getDefaultCases()
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 根据分类加载案例
    loadCasesByCategory(category) {
      this.loading = true
      getCasesByCategory(category)
        .then(response => {
          if (response.code === 200) {
            this.cases = response.data || response.rows || []
          } else {
            this.$message.error(response.msg || '获取案例列表失败')
            // 如果API失败，使用默认数据作为降级方案
            this.cases = this.getDefaultCases().filter(c => c.category === category)
          }
        })
        .catch(error => {
          console.error('获取案例列表失败:', error)
          this.$message.error('获取案例列表失败，请稍后重试')
          // 使用默认数据作为降级方案
          this.cases = this.getDefaultCases().filter(c => c.category === category)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 默认数据（作为降级方案）
    getDefaultCases() {
      return [
        {
          id: 1,
          title: '聚赫新材料LOGO设计-技术VI设计公司',
          description: '标志设计说明设计理念聚赫新材的LOGO设计以GHZ作为设计基础，这三个字母不仅代表了公司的名称，更蕴含了深远的意义。',
          category: 'logo'
        },
        {
          id: 2,
          title: '芬兰光浴（Finlight）品牌设计vi-医美logo设计',
          description: '芬兰光浴（Finlight）品牌标志的设计，不仅是一种视觉的艺术表达，更是一种文化的象征和品牌价值的传达。',
          category: 'logo'
        }
      ]
    },
    goToDetail(id) {
      this.$router.push(`/case-detail/${id}`)
    }
  }
}
</script>

<style scoped>
.m-case-g1 {
  padding: 60px 0 50px;
  overflow: hidden;
  background-color: #fff;
}

.m-case-g1 .ul-tab-g1 {
  margin-bottom: 45px;
}

.g-tit-g1 {
  text-align: center;
  margin-bottom: 52px;
  overflow: hidden;
}

.g-tit-g1 h3 {
  font-size: 36px;
  color: #242526;
  line-height: 1.4;
  font-weight: 400;
  margin-bottom: 6px;
}

.g-tit-g1 p {
  font-size: 24px;
  color: #666;
  line-height: 1.4;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.ul-tab-g1 {
  font-size: 0;
  text-align: center;
  list-style: none;
  padding: 0;
  margin: 0;
}

.ul-tab-g1 li {
  display: inline-block;
  margin: 0;
}

.ul-tab-g1 li a {
  display: block;
  font-size: 16px;
  color: #242526;
  line-height: 45px;
  padding: 0 14px;
  min-width: 70px;
  text-align: center;
  transition: 0.5s;
  text-decoration: none;
  cursor: pointer;
}

.ul-tab-g1 a:hover,
.ul-tab-g1 li.on a {
  color: #fff;
  background-color: #EA4043;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
}

.tab-con1 {
  height: 0;
  visibility: hidden;
  overflow: hidden;
}

.tab-con1.ok {
  height: auto;
  visibility: visible;
  overflow: visible;
}

.ul-pic-g2 {
  overflow: hidden;
  list-style: none;
  padding: 0;
  margin: 0 -1px -1px 0;
}

.ul-pic-g2 li {
  float: left;
  width: 33.333%;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  border-right: 1px solid transparent;
  border-bottom: 1px solid transparent;
}

.ul-pic-g2 .con {
  display: block;
  padding-top: 58.8%;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.ul-pic-g2 .pic {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.case-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.placeholder-image {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 15px;
  text-align: center;
  padding: 20px;
  font-weight: 300;
  letter-spacing: 0.5px;
}

.ul-pic-g2 .txt {
  position: absolute;
  left: 0;
  top: 100%;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 2;
  transition: 0.5s;
}

.ul-pic-g2 .txt .bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1;
}

.ul-pic-g2 .txt .inner {
  position: absolute;
  left: 0;
  top: 50%;
  padding: 0 25px;
  transform: translateY(-50%);
  margin-top: -5px;
  z-index: 2;
}

.ul-pic-g2 .txt p {
  font-size: 20px;
  color: #fff;
  line-height: 1.8;
  max-height: 144px;
  overflow: hidden;
}

.ul-pic-g2 .txt .more {
  display: block;
  font-size: 18px;
  color: #fff;
  width: 150px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  background-color: #EA4043;
  margin-top: 24px;
  text-decoration: none;
  transition: opacity 0.3s;
}

.ul-pic-g2 .con:hover .txt {
  top: 0;
}

.ul-pic-g2 .txt .more:hover {
  opacity: 0.8;
}

@media (max-width: 1200px) {
  .ul-pic-g2 li {
    width: 33.333%;
  }
}

@media (max-width: 768px) {
  .m-case-g1 {
    padding: 40px 0 30px;
  }
  
  .m-case-g1 .wp {
    padding: 0;
  }

  .g-tit-g1 {
    margin-bottom: 30px;
  }

  .g-tit-g1 h3 {
    font-size: 28px;
  }

  .g-tit-g1 p {
    font-size: 18px;
  }

  .m-case-g1 .ul-tab-g1 {
    margin-bottom: 30px;
  }

  .ul-tab-g1 li a {
    padding: 0 10px;
    font-size: 14px;
    min-width: 60px;
  }

  .ul-pic-g2 li {
    width: 50%;
  }

  .ul-pic-g2 .txt p {
    font-size: 16px;
  }

  .ul-pic-g2 .txt .more {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .ul-pic-g2 li {
    width: 100%;
  }
}
</style>
